<template>
  <div class="content">
    <section class="title"></section>
    <section class="date">
      <div>{{ this.time || '' }}</div>
    </section>
    <section class="main">
      <div class="pollen">
        广州花粉浓度
        <span class="number">{{ pollenObj.grade || 0 }}</span> 级
        <span class="level" :class="`level${pollenObj.grade}`"
          >({{ pollenObj.gradeDescribe || getLevel(pollenObj.grade) }})</span
        >
      </div>
      <div class="size pollen">
        <span class="number">{{ pollenObj.averageValue || 0 }}</span>
        粒/1000mm<sup>2</sup>
      </div>
      <ul class="desc">
        <li class="item header">
          <span>等级</span>
          <span>等级描述</span>
          <span class="sup">花粉浓度(粒/1000mm<sup>2</sup>)</span>
          <span>等级说明</span>
        </li>
        <li v-for="item in pollenTipList" :key="item.level" class="item">
          <span>{{ item.level }}</span>
          <span>{{ item.levelName }}</span>
          <span>{{ item.concentration }}</span>
          <span>{{ item.describe }}</span>
        </li>
      </ul>
      <div @click="openVideo" class="video">*对花粉过敏人群的防护建议*</div>
      <div class="map">
        <div>
          <img :src="imgBase64" alt="花粉浓度指数" />
        </div>
      </div>
      <div class="btm">
        <h4>全国局部花粉等级一览图</h4>
        <p>
          注：广州花粉数据来自省气象局五山观测站花粉观测点，全国花粉等级来自北京气象中心
        </p>
        <p>花粉浓度等级参考中国气象局《花粉过敏气象指数》（QX/T 324-2016）</p>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import { getServeTime } from '@/utils/time'
export default {
  name: 'PollenPage',
  data() {
    return {
      apiUrl: '/api-air-quality/tokens/pollen/list', // http://59.41.9.54 api地址
      apiTime: '',
      pollenObj: {}, //花粉数据
      time: '',
      loading: '',
      pollenTipList: [
        {
          level: '1级',
          grade: 1,
          concentration: 'N≤100',
          levelName: '低',
          describe: '气象条件极不易诱发花粉过敏症状'
        },
        {
          level: '2级',
          grade: 2,
          concentration: '101≤N<250',
          levelName: '较低',
          describe: '气象条件不易诱发花粉过敏症状'
        },
        {
          level: '3级',
          grade: 3,
          concentration: '251≤N≤400',
          levelName: '中等',
          describe: '气象条件可诱发花粉过敏症状'
        },
        {
          level: '4级',
          grade: 4,
          concentration: '401≤N≤800',
          levelName: '高',
          describe: '气象条件易诱发花粉过敏症状'
        },
        {
          level: '5级',
          grade: 5,
          concentration: 'N >800',
          levelName: '很高',
          describe: '气象条件极易诱发花粉过敏症状'
        }
      ],
      imgBase64: '',
      average: {}
    }
  },
  mounted() {
    document.title = '花粉浓度指数'
    this.getTime()
    this.getData()
  },
  methods: {
    openVideo() {
      let url =
        'https://vd2.bdstatic.com/mda-nda18qe8pa6at0mn/hd/cae_h264_delogo/1649640475816316413/mda-nda18qe8pa6at0mn.mp4?v_from_s=bdapp-landingpage-hna'
      const parm =
        '\u003cscript\u003elocation.replace("' + url + '")\u003c/script\u003e'
      const str = 'javascript:window.name;'
      window.open(str, parm)
    },
    //获取数据
    getData() {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios
        .get(this.apiUrl + `?pollenTime=${this.apiTime}`)
        .then(({ data }) => {
          let arr = data?.data?.pollenList || []
          this.pollenObj = arr[0] || {}
          this.imgBase64 = data?.data?.picture || ''
          this.loading.close()
        })
        .catch((e) => {
          this.pollenObj = {}
          this.imgBase64 = ''
          this.loading.close()
          this.$message.error('获取数据错误。')
        })
    },
    //获取时间
    getTime() {
      let { apiTime = '', time = '' } = getServeTime()
      this.apiTime = apiTime
      this.time = time
    },
    getLevel(level) {
      if (!level) return
      let val = this.pollenTipList.find((i) => i.grade == level).levelName
      return val
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:math';
@media screen and (min-width: 1201px) and (max-width: 4000px) {
  $designWidth: 1920;
  $designHeight: 1080;
  @function getVw($px) {
    @return math.div($px, $designWidth) * 100vw;
  }
  @function getVh($px) {
    @return math.div($px, $designHeight) * 100vh;
  }
  @mixin bg-set() {
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  @mixin bgColor-set($color, $radius) {
    background: $color;
    border-radius: $radius;
  }
  @mixin font-set($size, $color) {
    font-size: $size;
    color: $color;
  }
  .content {
    width: getVw(1080);
    height: getVh(1920);
    margin: 0 auto;
    background-image: url(~@/assets/image/pollen/bg.png);
    @include bg-set();
    box-sizing: border-box;
    overflow: hidden;
    padding-top: getVh(70);
    .title {
      width: getVw(630);
      height: getVh(100);
      background-image: url(~@/assets/image/pollen/title.png);
      @include bg-set();
      margin: 0 auto getVh(60) auto;
    }
    .date {
      display: flex;
      justify-content: center;
      height: getVh(76);
      margin: 0 auto getVh(60) auto;
      line-height: getVh(76);
      @include font-set(getVh(50), #fff);
      > div {
        padding: 0 getVw(28);
        @include bgColor-set(#ca3080, getVw(38));
      }
    }
    .main {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: getVw(946);
      height: getVh(1458);
      margin: 0 auto;
      @include bgColor-set(#fefefe, getVw(18));
      padding: getVh(50) getVw(60) 0 getVw(60);
      box-sizing: border-box;
      .pollen {
        @include font-set(getVh(60), #000);
        .number {
          font-weight: 600;
          @include font-set(getVh(80), #c46060);
        }
        .level {
          padding: getVh(4) getVw(18);
          line-height: getVh(60);
          &.level1 {
            background-color: #b5dbd5;
          }
          &.level2 {
            background-color: #abd5f3;
          }
          &.level3 {
            background-color: #f6d3a7;
          }
          &.level4 {
            background-color: #f5d5dd;
          }
          &.level5 {
            background-color: #d1acd0;
          }
        }
      }
      .size {
        margin-bottom: getVh(40);
      }
      .desc {
        width: getVw(804);
        height: getVh(306);
        border: 1px solid #d22f41;
        margin-bottom: getVh(20);
        @include font-set(getVh(20), #000);
        font-weight: 600;
        border-radius: getVh(20);
        li {
          display: flex;
          height: getVh(50);
          line-height: getVh(50);
          border-bottom: 1px solid #fff;
          &:nth-child(2) {
            background-image: linear-gradient(to right, #b5dbd5, #fff);
          }
          &:nth-child(3) {
            background-image: linear-gradient(to right, #abd5f3, #fff);
          }
          &:nth-child(4) {
            background-image: linear-gradient(to right, #f6d3a7, #fff);
          }
          &:nth-child(5) {
            background-image: linear-gradient(to right, #f5d5dd, #fff);
          }
          &:last-child {
            border-bottom: none;
            border-radius: 0 0 getVh(20) getVh(20);
            background-image: linear-gradient(to right, #d1acd0, #fff);
            span:last-child {
              border-radius: 0 0 getVh(20) 0;
            }
          }
          &:first-child {
            background-image: linear-gradient(to right, #c6c5c6, #fefefe);
            border-radius: getVh(20) getVh(20) 0 0;
            span:last-child {
              border-radius: 0 getVh(20) 0 0;
            }
          }
          span {
            text-align: center;
            border-right: 1px solid #fff;
          }
          span:nth-child(1) {
            width: getVw(80);
          }
          span:nth-child(2) {
            width: getVw(100);
          }
          span:nth-child(3) {
            width: getVw(260);
            &.sup {
              line-height: getVh(36);
            }
          }
          span:nth-child(4) {
            flex: 1;
          }
        }
      }
      .video {
        width: 100%;
        text-align: right;
        color: #c46060;
        font-size: getVh(18);
        margin-bottom: getVh(14);
        cursor: pointer;
      }
      .map {
        width: getVw(820);
        height: getVh(600);
        padding: getVh(28) getVw(54);
        box-sizing: border-box;
        @include bgColor-set(#f7e0e6, getVw(34));
        margin-bottom: getVh(26);
        > div {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          @include bgColor-set(#fff, getVw(0));
        }
        img {
          width: getVw(656);
          height: getVh(500);
        }
      }
    }
    .btm {
      text-align: center;
      @include font-set(getVh(20), #222);
      p {
        line-height: getVh(34);
      }
      h4 {
        font-weight: 600;
        @include font-set(getVh(24), #222);
        margin-bottom: getVh(20);
      }
    }
  }
}

@media screen and (min-width: 350px) and (max-width: 1200px) {
  $designWidth: 1080;
  $designHeight: 1920;
  @function getVw($px) {
    @return math.div($px, $designWidth) * 100vw;
  }
  @function getVh($px) {
    @return math.div($px, $designHeight) * 100vh;
  }
  @mixin bg-set() {
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  @mixin bgColor-set($color, $radius) {
    background: $color;
    border-radius: $radius;
  }
  @mixin font-set($size, $color) {
    font-size: $size;
    color: $color;
  }
  .content {
    width: getVw(1080);
    height: getVh(1920);
    margin: 0 auto;
    background-image: url(~@/assets/image/pollen/bg.png);
    @include bg-set();
    box-sizing: border-box;
    overflow: hidden;
    padding-top: getVh(70);
    .title {
      width: getVw(630);
      height: getVh(100);
      background-image: url(~@/assets/image/pollen/title.png);
      @include bg-set();
      margin: 0 auto getVh(60) auto;
    }
    .date {
      display: flex;
      justify-content: center;
      height: getVh(76);
      margin: 0 auto getVh(60) auto;
      line-height: getVh(76);
      @include font-set(getVh(50), #fff);
      > div {
        padding: 0 getVw(28);
        @include bgColor-set(#ca3080, getVw(38));
      }
    }
    .main {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: getVw(946);
      height: getVh(1458);
      margin: 0 auto;
      @include bgColor-set(#fefefe, getVw(18));
      padding: getVh(50) getVw(60) 0 getVw(60);
      box-sizing: border-box;
      .pollen {
        @include font-set(getVh(60), #000);
        .number {
          font-weight: 600;
          @include font-set(getVh(80), #c46060);
        }
        .level {
          padding: getVh(4) getVw(18) 0;
          line-height: getVh(60);
          &.level1 {
            background-color: #b5dbd5;
          }
          &.level2 {
            background-color: #abd5f3;
          }
          &.level3 {
            background-color: #f6d3a7;
          }
          &.level4 {
            background-color: #f5d5dd;
          }
          &.level5 {
            background-color: #d1acd0;
          }
        }
      }
      .size {
        margin-bottom: getVh(40);
      }
      .desc {
        width: getVw(804);
        height: getVh(308);
        border: 1px solid #d22f41;
        margin-bottom: getVh(20);
        @include font-set(getVh(20), #000);
        font-weight: 600;
        border-radius: getVh(20);
        li {
          display: flex;
          height: getVh(50);
          line-height: getVh(50);
          border-bottom: 1px solid #fff;
          &:nth-child(2) {
            background-image: linear-gradient(to right, #b5dbd5, #fff);
          }
          &:nth-child(3) {
            background-image: linear-gradient(to right, #abd5f3, #fff);
          }
          &:nth-child(4) {
            background-image: linear-gradient(to right, #f6d3a7, #fff);
          }
          &:nth-child(5) {
            background-image: linear-gradient(to right, #f5d5dd, #fff);
          }
          &:last-child {
            border-bottom: 1px solid #d22f41;
            border-radius: 0 0 getVh(20) getVh(20);
            background-image: linear-gradient(to right, #d1acd0, #fff);
            span:last-child {
              border-radius: 0 0 getVh(20) 0;
            }
          }
          &:first-child {
            background-image: linear-gradient(to right, #c6c5c6, #fefefe);
            border-radius: getVh(20) getVh(20) 0 0;
            span:last-child {
              border-radius: 0 getVh(20) 0 0;
            }
          }
          span {
            text-align: center;
            border-right: 1px solid #fff;
          }
          span:nth-child(1) {
            width: getVw(80);
          }
          span:nth-child(2) {
            width: getVw(100);
          }
          span:nth-child(3) {
            width: getVw(260);
            &.sup {
              line-height: getVh(36);
            }
          }
          span:nth-child(4) {
            flex: 1;
          }
        }
      }
      .video {
        width: 100%;
        text-align: right;
        color: #c46060;
        font-size: getVh(18);
        margin-bottom: getVh(14);
        cursor: pointer;
      }
      .map {
        width: getVw(820);
        height: getVh(600);
        padding: getVh(28) getVw(54);
        box-sizing: border-box;
        @include bgColor-set(#f7e0e6, getVw(34));
        margin-bottom: getVh(26);
        > div {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          @include bgColor-set(#fff, getVw(0));
        }
        img {
          width: getVw(656);
          height: getVh(500);
        }
      }
    }
    .btm {
      text-align: center;
      @include font-set(getVh(20), #222);
      p {
        line-height: getVh(34);
      }
      h4 {
        font-weight: 600;
        @include font-set(getVh(24), #222);
        margin-bottom: getVh(20);
      }
    }
  }
}
ul {
  list-style: none;
}
</style>
